class ProductSidebar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sidebar = document.querySelector('.product-group--bottom');
    this.main = document.querySelector('.product-group--top');
    this.sticky = document.querySelector('.sticky-atc');

    if (!this.sidebar || !this.main) return;
    
    this.scroll = this.scrollSidebar.bind(this);
    this.resize = this.resizeSidebar.bind(this);

    this.sidebar_width = this.sidebar.offsetWidth;

    if (!Shopify.designMode) {
      document.addEventListener('scroll', this.scroll)
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) return;
    document.removeEventListener('scroll', this.scroll)
  }

  resizeSidebar() {
    this.sidebar_width = this.sidebar.offsetWidth;
  }

  scrollSidebar() {
    if (window.innerWidth < 1002) return;
    const sidebar_height = this.sidebar.offsetHeight;
    const main_height = this.main.offsetHeight;
    if (sidebar_height > main_height) return;

    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    const w = this.sidebar.querySelector(':scope > div');
    if (!w) return;
    w.style.transition = 'bottom 0.4s cubic-bezier(0.25, 1, 0.5, 1)';
    const sticky_height = this.sticky.offsetHeight

    if (scrollY + windowHeight - sticky_height - 150 > main_height) {
        w.style.position = 'absolute';
        w.style.width = this.sidebar_width + 'px';
        if (this.sticky) {
            w.style.bottom = sticky_height + 'px';
        } else {
            w.style.bottom = 0;
        }
    } else if (scrollY + windowHeight > sidebar_height) {
        w.style.position = 'fixed';
        w.style.width = this.sidebar_width + 'px';
        if (this.sticky) {
            w.style.bottom = sticky_height + 'px';
        } else {
            w.style.bottom = 0;
        }
    } else {
        w.style.position = 'relative';
        w.style.bottom = 'auto';
    }
  }
}
if (!customElements.get('product-sidebar')) customElements.define('product-sidebar', ProductSidebar);
